import * as ActionTypes from '../actions/types/PromoMessageActionTypes';

const initialState = {
  message: '',
  link: '',
  promoMessageLoaded: false,
  busy: false,
};

const promoMessage = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_PROMO_MESSAGE:
      return {
        ...state,
        message: action.payload.message,
        link: action.payload.link,
        backgroundColor: action.payload.background_color,
        textColor: action.payload.text_color,
        promoMessageLoaded: true,
      };
    case ActionTypes.REQUEST_PROMO_MESSAGE:
      return { ...state, busy: true };
    default:
      return state;
  }
};

export default promoMessage;
